<template>
  <div class="tab-six-ps">
    <el-form class="form-wrapper" label-width="80px">
      <el-form-item label="学校">
        <el-select v-model="local_filter_school" multiple collapse-tags placeholder="请选择(支持多选)">
          <el-option v-for="item in kSchoolOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="方向">
        <el-select v-model="local_filter_project_direction" multiple collapse-tags placeholder="请选择(支持多选)">
          <el-option v-for="item in kProjectDirectionOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="项目">
        <el-input v-model="local_filter_project" placeholder="请输入项目关键词"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="local_filter_state" multiple collapse-tags placeholder="请选择(支持多选)">
          <el-option v-for="item in kStateOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button @click="filterAction" style="margin-left: 10px" type="primary">筛选</el-button>
    </el-form>
    <el-table v-loading="loading" :data="lists" style="width: 100%" empty-text="请等待老师添加选校">
      <el-table-column prop="sort_id" sortable label="编号" align="center" />

      <el-table-column prop="project_name" label="项目" align="center">
        <template slot-scope="scope">
          <div style="word-break: break-word">{{ scope.row.project_name }}</div>
        </template>
      </el-table-column>

      <el-table-column label="学校" align="center">
        <template slot-scope="scope">
          <div style="word-break: break-word">
            {{ scope.row.user_school_choice.school_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="方向" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.user_school_choice.project_direction">
            {{ scope.row.user_school_choice.project_direction }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="" label="培养目标" align="center">
        <template slot-scope="scope">
          <el-link v-if="
            scope.row.user_school_choice &&
            scope.row.user_school_choice.train_objective
          " @click="
              detailInfoDialog = scope.row.user_school_choice.train_objective
              " type="primary">查看</el-link>
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column prop="" label="课程设置" align="center">
        <template slot-scope="scope">
          <el-link v-if="
            scope.row.user_school_choice &&
            scope.row.user_school_choice.curriculum
          " @click="detailInfoDialog = scope.row.user_school_choice.curriculum" type="primary">查看</el-link>
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column prop="" label="官网文书要求" align="center">
        <template slot-scope="scope">
          <el-link v-if="scope.row.user_school_choice && scope.row.user_school_choice.official_website_documents"
            @click="showDetailInfoDialog(scope.row.user_school_choice)" type="primary">查看</el-link>
          <p v-else>--</p>
        </template>
      </el-table-column> -->
      <el-table-column prop="name" label="文书" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.name">
            <el-link type="primary" @click="
              () => {
                previewUrl = scope.row.upload_documents[0].url;
                previewName = scope.row.upload_documents[0].name;
              }
            ">预览/下载
            </el-link>
            <p v-if="scope.row.document_status == 1" style="color: red;margin: 0">[终稿]</p>
            <p v-if="scope.row.document_status == 2" style="color: red;margin: 0">[草稿,请勿确认]</p>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="文书记录" prop="" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="logDocumentPs(scope.row)"
            >查看</el-link
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.status == 3" style="color: #f56c6c">待确认</p>
          <p v-if="scope.row.status == 1" style="color: #08a0eeff">已确认</p>
          <el-link v-if="scope.row.status == 2" type="danger"
            @click="reasonRejectionUserSchoolChoice(scope.row.content, scope.row.reject_type)">已驳回，待老师修改</el-link>
          <p v-if="scope.row.status == 0" style="color: #f56c6c">待老师上传</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" prop="updated_at">
        <template slot-scope="scope">
          <div v-if="scope.row.name && scope.row.name.length > 0" class="operation">
            <div class="btns-wrapper">
              <el-popconfirm title="是否确认？" class="btn" @confirm="updateStatus(scope.row.id, 1)"
                v-if="scope.row.status == 3">
                <el-button slot="reference" size="mini" type="primary">确认</el-button>
              </el-popconfirm>
              <el-button v-if="scope.row.status == 3" size="mini" type="danger" class="btn"
                @click="refuseUserSchoolChoice(scope.row.id)">驳回</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.name">{{ scope.row.updated_at }}</p>
          <p v-else></p>
        </template>
      </el-table-column>
    </el-table>

    <reject ref="reject" @reject="getList" :needFile="true"></reject>
    <reason_rejection ref="reason_rejection"></reason_rejection>

    <!--文书上传弹窗-->
    <show_document ref="showDocument" />
    <!--文书显示弹窗-->
    <upload_document ref="uploadDocument" @show_list="getList" />
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="
      previewUrl = null;
    previewName = null;
    " />
    <el-dialog center title="查看" :visible="detailInfoDialog" width="50%"
      :before-close="() => (detailInfoDialog = null)">
      <p style="white-space: pre-wrap; font-size: 16px">
        {{ detailInfoDialog }}
      </p>
    </el-dialog>

    <el-dialog center title="查看" :visible="officialWebsiteDocumentsDialog" width="50%"
      :before-close="() => (officialWebsiteDocumentsDialog = false)">
      <p style="white-space: pre-wrap; ">
        {{ officialWebsiteDocuments }}
      </p>
      <p style="white-space: pre-wrap; ">
        <el-link :href="officialWebsiteUrl" target="_blank"> {{ officialWebsiteUrl }}</el-link>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import {
  document_list,
  del_document,
  user_information_document_edit,
} from "@/api/mycenter_studyabroad";
import show_document from "./show_document";
import upload_document from "./upload_document";
import reject from "./reject";
import { downloadFile } from "@/api/file";
import reason_rejection from "./reason_rejection.vue";
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview";
export default {
  name: "TabSixPs",
  components: {
    show_document,
    upload_document,
    reject,
    reason_rejection,
    HBFilePreview,
  },
  data() {
    return {
      local_filter_project: undefined,
      local_filter_school: [],
      local_filter_project_direction: [],
      local_filter_state: [],
      officialWebsiteDocumentsDialog: false,
      detailInfoDialog: null,
      previewUrl: null,
      previewName: null,
      refuseId: "", // 驳回id
      reason: "", // 拒绝理由
      dialogAddUserSchoolChoice: false,
      dataSource: [],
      lists: [], // 数据列表
      requestData: {
        type: "jxj",
        loading: "",
      },
      officialWebsiteDocuments: '',
      officialWebsiteUrl: '',
      content: {
        title: "",
        type: "",
        name: "",
        operate: "",
        id: "",
      },
    };
  },
  computed: {
    kStateOptions() {
      return [
        {
          label: "已驳回",
          value: 2,
        },
        {
          label: "待确认",
          value: 3,
        },
        {
          label: "已确认",
          value: 1,
        },
        {
          label: "待老师上传",
          value: 0,
        },
      ];
    },
    kSchoolOptions() {
      if (this.dataSource && this.dataSource.length > 0) {
        const l = [];
        this.dataSource.forEach((item) => {
          const index = l.findIndex(
            (subItme) => subItme.label == item.user_school_choice.school_name
          );
          if (index < 0) {
            l.push({
              label: item.user_school_choice.school_name || "",
              value: item.user_school_choice.school_name || "",
            });
          }
        });
        return l;
      } else {
        return [];
      }
    },
    kProjectDirectionOptions() {
      console.log('this.dataSource', this.dataSource)
      if (this.dataSource && this.dataSource.length > 0) {
        const l = [];
        this.dataSource.forEach((item) => {
          const index = l.findIndex(
            (subItme) => subItme.label == item.user_school_choice.project_direction
          );
          if (index < 0) {
            l.push({
              label: item.user_school_choice.project_direction || "",
              value: item.user_school_choice.project_direction || "",
            });
          }
        });
        return l;
      } else {
        return [];
      }
    },
  },
  created() {
    this.getList(true);
  },
  methods: {
    showDetailInfoDialog(_data) {
      this.officialWebsiteDocumentsDialog = true
      this.officialWebsiteDocuments = _data.official_website_documents
      this.officialWebsiteUrl = _data.official_website_url
    },
    filterAction() {
      if (
        !this.local_filter_project &&
        (!this.local_filter_school || this.local_filter_school.length == 0) &&
        (!this.local_filter_project_direction || this.local_filter_project_direction.length == 0) &&
        (!this.local_filter_state || this.local_filter_state.length == 0)
      ) {
        this.lists = this.dataSource;
        return;
      }
      const resultList = [];
      const schoolList = this.local_filter_school || [];
      const projectDirectionList = this.local_filter_project_direction || [];
      const stateList = this.local_filter_state || [];
      const project = this.local_filter_project;

      this.dataSource.forEach((item) => {
        var flag = true;
        if (
          schoolList.length > 0 &&
          !schoolList.includes(item.user_school_choice.school_name)
        ) {
          flag = false;
        }
        if (
          projectDirectionList.length > 0 &&
          !projectDirectionList.includes(item.user_school_choice.project_direction)
        ) {
          flag = false;
        }
        if (stateList.length > 0 && !stateList.includes(item.status)) {
          flag = false;
        }
        if (
          project &&
          !item.user_school_choice.project_name
            .toLocaleLowerCase()
            .includes(project.toLocaleLowerCase())
        ) {
          flag = false;
        }
        if (flag == true) {
          resultList.push(item);
        }
      });
      this.lists = resultList;
    },

    downLoad(url, name) {
      downloadFile(url, name);
    },
    reasonRejectionUserSchoolChoice(content, reject_type) {
      content = JSON.parse(content);
      this.$refs.reason_rejection.sendItem(content.content, content.url, reject_type);
    },
    refuseUserSchoolChoice(id) {
      this.$refs.reject.sendItem(id, "jxj", 2);
    },
    updateStatus(id, status) {
      var reason = this.reason;
      user_information_document_edit({
        id: id,
        con: reason,
        status: status,
        type: "jxj",
      }).then((response) => {
        this.dialogAddUserSchoolChoice = false;
        this.getList();
      });
    },
    getList() {
      this.loading = true;
      document_list(this.requestData)
        .then((response) => {
          this.loading = false;
          const dataList = response.data || [];
          this.dataSource = dataList;
          this.lists = dataList;
          this.filterAction();
        })
        .catch((error) => { });
    },
    addDocumentPs(item) {
      this.content.type = "jxj";
      this.content.id = item.id;
      this.content.operate = "add";
      this.content.title = "添加jxj";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    editDocumentPs(item) {
      this.content.type = "jxj";
      this.content.id = item.id;
      this.content.name = item.name.substring(0, item.name.indexOf("-"));
      this.content.operate = "edit";
      this.content.title = "修改jxj";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    logDocumentPs(content) {
      this.$refs.showDocument.sendItem(content.upload_documents);
    },
    delDocumentPs(id) {
      del_document({ id: id, type: "jxj" }).then((response) => {
        this.getList(true);
      });
    },
  },
};
</script>
<style scoped lang="scss">
.tab-six-ps {
  .form-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }

  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .btn {
      margin-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_six_jxj.vue